<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Dynamic Page Text</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="dynamic-page-text/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add Dynamic Page Text
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Dynamic Page Text List</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="dynamicPageTextList" :fields="tableFields">
                <template #cell(description)="row">
                  <span style="max-width: 200px" class="d-inline-block" v-html="row.item.description[$i18n.locale]"></span>
                </template>
                <template #cell(status)="row">
                  <span class="badge text-white" :class="{'bg-success': row.item.status === 'active', 'bg-danger': row.item.status !== 'active'}">{{row.item.status}}</span>
                </template>
                <template #cell(is_current)="row">
                  <input class="pointer" @click="setIsCurrent(row.item)" type="radio" name="radio" :checked="row.item.is_current"/>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`dynamic-page-text/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="deleteCreatedDynamicPageText(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restoreDynamicPageTextInList(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="deleteCreatedDynamicPageText(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'DynamicPageText',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      dynamicPageTextList: state => state.dynamicPageText.dynamicPageTextList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'dynamic_page.title.' + this.$i18n.locale,
          label: 'page',
          sortable: true
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true
        },
        {
          key: 'status',
          sortable: true
        },
        {
          key: 'is_current',
          label: 'Current',
          sortable: false
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getDynamicPageTexts({})
  },
  methods: {
    ...mapActions({
      getAllDynamicPageTexts: 'dynamicPageText/getAllDynamicPageTexts',
      deleteDynamicPageText: 'dynamicPageText/deleteDynamicPageText',
      restoreDynamicPageText: 'dynamicPageText/restoreDynamicPageText',
      setCurrentDynamicPageText: 'dynamicPageText/setCurrentDynamicPageText'
    }),
    changePaginationPerPage (value) {
      this.getDynamicPageTexts({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getDynamicPageTexts({ page: page, count: this.paginationPerPage })
    },
    getDynamicPageTexts (params) {
      this.getAllDynamicPageTexts(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    setIsCurrent (item) {
      if (!item.is_current) {
        this.setCurrentDynamicPageText({ id: item.id }).then(res => {
        }).catch(() => {
          this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
        })
      }
    },
    deleteCreatedDynamicPageText (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteDynamicPageText({ id }).then(res => {
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restoreDynamicPageTextInList (id) {
      this.restoreDynamicPageText({ id }).then(res => {
      })
    }
  }
}
</script>
